// Protection of selling personal information under California or Nevada law
export const CCPA_STATE_COOKIE_NAME = 'dnsmpi';

/*
    CUSTOM_TABLET is a work around solution to fix the issue of the iframe
    caused by getting the wrong window width when there a map in the page, which led the iframe
    to get the parent container width and consider it for the breakpoint
 */
export const CUSTOM_TABLET_FIGURE_MIN_WIDTH = 992;
export const CUSTOM_TABLET_FIGURE_MAX_WIDTH = 1200;
export const CUSTOM_X_LARGE_FIGURE_MAX_WIDTH = 1920;
export const DESKTOP_BREAKPOINT = 768;
export const MOBILE_BREAKPOINT = 375;
export const MESO_ALTER_CLASS = 'MESO_ALTER_CLASS';

export const MESO_AD_EVENTS = {
    PASS: 'AD-LOAD-PASS',
    FAIL: 'AD-LOAD-FAIL',
    EMPTY: 'AD-LOAD-EMPTY',
};

export const MESO_SLOT_STATUSES = {
    LOADING: 'loading',
    FAILED: 'failed',
    LOADED: 'loaded',
    RENDERING_FAILURE: 'RENDERING-FAILURE'
};

export const HOUSE_AD_CAMPAIN_IDS = ['2686042700'];
